export enum EntityType {
  Availability = 'availability',
  Property = 'property',
  LeaseComp = 'lease',
  SaleComp = 'sale',
  PortfolioSale = 'portfoliosale',
  Company = 'company',
  Contact = 'contact',
  Tim = 'tim',
  Tenancy = 'tenancy',
  Brand = 'brand',
  Complex = 'complex',
  Tenants = 'tenants',
}

export enum EntityRecordType {
  Property = 'property_building',
  LeaseComp = 'lease_comp',
}

export enum EdpEntityMap {
  property_building = 'property',
  lease_comp = 'lease',
  sale_comp = 'sale',
  tenant = 'tenancy',
}
